import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  declarationId: string;
  file: File;
  documentData: {
    type: string;
    referenceNumber: string;
    description: string;
  };
}

export const useUploadProvidedDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ declarationId, file, documentData }: HookProps) => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', documentData.type);
      formData.append('referenceNumber', documentData.referenceNumber);
      formData.append('description', documentData.description);

      const { data } = await request({
        path: `declarations/${declarationId}/upload-provided-document`,
        method: 'POST',
        authenticate: true,
        dataObject: formData,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.declarationId] });
      toast.success('Document uploaded successfully!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error uploading the document!');
    },
  });
};
